import React from 'react';
import Header from './Header';
import Footer from './Footer';

const PrivacyNotice: React.FC = () => (
  <div className="page-container">
    <Header />
    <main className="page-content">
      <h1>Privacy Notice</h1>
      <p>
        At Consphic, we are committed to protecting your privacy. This Privacy Notice explains how we collect, use, and safeguard your information when you use our website and services. We only collect personal data necessary to provide our solutions, and we never sell your information to third parties. For more details, please contact our support team.
      </p>
    </main>
    <Footer />
  </div>
);

export default PrivacyNotice;
